export default {
  title: 'Programas Educativos',
  suggest: 'Haz tu sugerencia',
  catalog: 'Ver catálogo',
  resourcesLabel: 'Recursos',
  durationLabel: 'Duración',
  ageRangeLabel: 'Edad',
  ageRange: '{minAge} a {maxAge} años',
  browse: 'Explorar el programa',
  lectures: 'Sin clases | Una clase | {n} clases',
  otherPrograms: 'Otros programas que pueden interesarte',
  category: {
    computationalThinking: 'Pensamiento computacional',
    globalCitizenship: 'Ciudadanía global',
    entrepreneurialSpirit: 'Espíritu emprendedor',
    krea: 'Krea',
    teachersTraining: 'Acompañamiento docente'
  },
  paginatedTable: {
    next: 'Siguiente',
    prev: 'Anterior'
  }
}

export const en = {
  title: 'Educational Programs',
  suggest: 'Send your suggestion',
  catalog: 'View catalogue',
  resourcesLabel: 'Resources',
  durationLabel: 'Duration',
  ageRangeLabel: 'Age',
  ageRange: '{minAge} to {maxAge} y/o',
  browse: 'Browse the program',
  lectures: 'No lectures | One lecture | {n} lectures',
  otherPrograms: 'Other programs you may be interested in',
  category: {
    computationalThinking: 'Computational thinking',
    globalCitizenship: 'Global citizenship',
    entrepreneurialSpirit: 'Entrepreneurial spirit',
    krea: 'Krea',
    teachersTraining: 'Teacher guidance'
  },
  paginatedTable: {
    next: 'Next',
    prev: 'Previous'
  }
}

export const ca = {
  title: 'Programes Educatius',
  suggest: 'Fes un suggeriment',
  catalog: 'Veure catàleg',
  resourcesLabel: 'Recursos',
  durationLabel: 'Durada',
  ageRangeLabel: 'Edat',
  ageRange: 'De {minAge} a {maxAge} anys',
  browse: 'Explora el programa',
  lectures: 'No hi ha classes | Una classe | {n} classes',
  otherPrograms: 'Altres programes que et poden interessar',
  category: {
    computationalThinking: 'Pensament computacional',
    globalCitizenship: 'Ciutadania global',
    entrepreneurialSpirit: 'Esperit emprenedor',
    krea: 'Krea',
    teachersTraining: 'Acompanyament docent'
  },
  paginatedTable: {
    next: 'Pròxim',
    prev: 'Anterior'
  }
}
